import { FunctionalComponent, h } from "@stencil/core"

export type Focusable = HTMLElement | { setFocus(): void }

export const focusElement = (element: Focusable) => {
  if ("setFocus" in element) {
    element.setFocus()
  } else {
    element.focus()
  }
}

export const FocusGuard: FunctionalComponent<{ moveFocusTo: Focusable }> = ({ moveFocusTo }) => {
  return <div class="duet-focus-guard" aria-hidden="true" tabIndex={0} onFocus={() => focusElement(moveFocusTo)} />
}
